module.exports = __webpack_public_path__ + "./favicons/apple-icon-precomposed.png";